
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M8.14 33.49v5.67M34 24.17v-8.48h5v8.48M1 24.16v-8.48h5v8.48M31.89 33.49v5.68"}}),_c('path',{attrs:{"d":"M36.65 15.7v-4.39a4.47 4.47 0 00-4.45-4.47H7.85A4.48 4.48 0 003.4 11.3v4.39M20.03 7.14l-.01 26.2M1 24.17h38v9.17H1z","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    